import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { getUserProfile } from '../services/api';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};

export const UserProvider = ({ children }) => {
  const { currentUser } = useAuth();
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUserProfile = async () => {
      if (currentUser && currentUser.uid) {
        setLoading(true);
        const result = await getUserProfile(currentUser.uid);
        if (result.success && result.profile) {
          setUserProfile(result.profile);
        }
        setLoading(false);
      } else {
        setUserProfile(null);
      }
    };

    fetchUserProfile();
  }, [currentUser]);

  const refreshProfile = async () => {
    if (currentUser && currentUser.uid) {
      setLoading(true);
      const result = await getUserProfile(currentUser.uid);
      if (result.success && result.profile) {
        setUserProfile(result.profile);
      }
      setLoading(false);
    }
  };

  const value = {
    userProfile,
    loading,
    refreshProfile
  };

  return (
    <UserContext.Provider value={value}>
      {children}
    </UserContext.Provider>
  );
};
